module.exports = __webpack_public_path__ + "static/media/logo-branca-texto.9526322e.svg";